import styled from "styled-components";

const StyledGetStarted = styled.div`
	.sb-get-started {
		background-color: #000000;

		* {
			font-family: "Inter", sans-serif;
		}

		.sb-button__inner {
		}

		span.highlight {
			color: #f95c25;
		}

		.clash-display {
			font-family: "Clash Display", sans;
			font-weight: 500;
		}

		.leadingbrands {
			height: 520px;
			width: 100%;
			background-size: cover;
			background-repeat: no-repeat;
			background-position-x: center;
			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					bottom: 160px;
				}
			}
		}

		.orange-btn {
			background-color: #f95c25;
			color: #ffffff;
			font-size: 16px;
		}
		.transparent-btn {
			background-color: transparent;
			border: 1px solid;
			color: #f95c25;
			font-size: 16px;
		}
		.black-btn {
			background-color: #141414;
			color: #ffffff;
			font-size: 16px;
		}

		&__main-section {
			height: 100vh;
			background-size: cover;
			background-position: center;
			display: flex;
			flex-direction: column;
			min-height: 400px;

			.header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px 80px 0 80px;
				z-index: 3;
				flex-wrap: wrap;

				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					justify-content: center;
				}

				.actions {
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						display: none;
					}
					button {
						width: max-content;
						min-width: 150px;
					}
					.transparent-btn {
						min-width: 150px;
					}
				}
			}

			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: -100vh;
				background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1));
			}
			.body {
				display: flex;
				flex-direction: column;
				gap: 16px;
				position: relative;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				width: 100%;
				padding: 0 24px;

				.title {
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						font-size: 40px;
					}
					font-size: 80px;
					color: white;
				}

				.subtitle {
					font-size: 24px;
					font-weight: 300;
					color: white;
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						font-size: 16px;
					}
				}
			}
			.actions {
				display: flex;
				justify-content: center;
				gap: 12px;
				padding: 24px 0;

				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					flex-direction: column;
					align-items: center;
				}

				button {
					width: max-content;
					min-width: 150px;
				}
			}
		}
		&__integration-section {
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				margin: 16px 32px;
				padding: 0px;
			}
			border-radius: 40px;
			padding: 64px;
			margin: 40px 80px 0px 80px;
			background-color: #fafafa;

			&__first-child {
				margin-bottom: 64px;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					margin-bottom: 0px;
				}
				&__integration-card {
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						text-align: center;
						align-items: center;
					}

					.circuit-section {
						background-size: contain;
						border-radius: 40px;
						background-position-x: right;
						background-repeat: no-repeat;
						.any-platform {
							font-size: 48px;
							font-weight: 600;
							text-align: left;
							@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
								font-size: 40px;
								text-align: center;
							}
							span {
								font-size: 48px;
								font-weight: 600;
								@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
									font-size: 40px;
								}
							}
						}
					}

					.ant-tag {
						border: 1px solid #00000073;
						border-radius: 50px;
						color: #00000073;
						font-family: "DM Sans", sans;
					}

					display: flex;
					flex-direction: column;
					gap: 16px;

					.paragraph-subtitle {
						font-size: 16px;
						font-weight: 300;
						padding: 0;
						color: rgba(0, 0, 0, 0.85);
					}

					.request-demo {
						width: max-content;
						min-width: auto;
					}
				}
			}
			&__second-child {
				.card-no-shadow {
					box-shadow: none;
					background-color: transparent;
					text-align: center;
				}
			}
		}
		.card-no-shadow {
			.ant-card-head-title {
				white-space: wrap;
			}
		}
		&__trusted-by-section {
			position: relative;
			.ant-row {
				padding: 0px !important;
				margin: 0px !important;
			}
			.gradient {
				width: 330px;
				height: 330px;
				position: absolute;
				border-radius: 50%;
				top: 20%;
				left: 30%;
				transform: translate(-50%, 0%);
				background: linear-gradient(to bottom right, rgb(255, 0, 0), rgb(255, 213, 0));
				filter: blur(7em);
				opacity: 0.3;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					left: 20%;
				}
			}

			&__image-container {
				padding: 180px 0px 20px 80px;
				background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));

				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					padding: 0px;
					margin-top: -160px;
					background-color: #000;
				}

				.vertical-container {
					position: relative;
					text-align: end;
					display: flex;
					align-items: center;
					&:first-child {
						justify-content: flex-end;
					}
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						margin-top: 16px;
						justify-content: center !important;
					}

					img.vertical {
						width: 80%;
					}
					.vertical-video-bg {
						background-size: cover;
						background-position: center;
						height: 450px;
						width: 221px;
						padding: 10px;
						position: relative;
						&::before {
							content: "";
							position: absolute;
							top: 4px;
							width: 80px;
							height: 20px;
							background-color: rgb(10, 10, 10);
							left: 50%;
							transform: translateX(-50%);
							z-index: 1;
							border-radius: 0 0 10px 10px;
						}
					}
					.horizontal-video {
						background-color: #000;
						border-radius: 30px;
					}
					video {
						object-fit: cover;
						border-radius: 30px;
					}
				}

				.horizontal-container {
					text-align: end;
					margin: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: 16px;
					.horizontal-video-bg {
						background-size: cover;
						background-position: center;
						width: 508px;
						height: 251px;
						padding: 10px;
						position: relative;
						&::before {
							content: "";
							position: absolute;
							left: 4px;
							height: 80px;
							width: 20px;
							background-color: rgb(10, 10, 10);
							top: 50%;
							transform: translateY(-50%);
							z-index: 1;
							border-radius: 0 10px 10px 0;
						}
					}
					.horizontal-video {
						background-color: #000;
						border-radius: 30px;
						video {
							object-fit: cover;
							border-radius: 30px;
						}
					}
					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						transform: scale(${({ screenWidth }) => 565 / 768});
					}
				}
			}

			&__info-container {
				.info-container-card {
					background: transparent;
					border: none;
					padding: 0px 80px 80px 80px;
					font-weight: 300;

					@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
						text-align: center;
						justify-content: center;
						padding: 0px;
						margin: 16px 20px;
						position: relative;
						top: -160px;
					}

					.title {
						font-size: 48px;
						line-height: 1;
					}
					.ant-card-body {
						padding: 0px 32px 32px 32px;
						padding-right: 80px;
						color: #ffffff;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						gap: 32px;
						&::before {
							display: none;
						}
						&::after {
							display: none;
						}

						@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
							padding: 0px;
						}

						p {
							font-weight: 300;
							font-size: 16px;
						}
						.request-demo {
							width: max-content;
							min-width: auto;
							@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
								align-self: center;
							}
						}
					}
				}
			}
		}
		&__blog-items-section {
			padding: 80px;

			.title {
				color: #ffffff;
				font-size: 40px;
			}
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				padding: 16px 32px;
			}
		}
		&__contact-section {
			padding: 80px;
			position: relative;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				padding: 0px;
				margin: 16px 20px;
			}

			.gradient {
				max-width: 440px;
				height: 440px;
				position: absolute;
				border-radius: 50%;
				top: 50%;
				left: 80%;
				transform: translate(-50%, 0%);
				background: linear-gradient(to bottom right, rgb(255, 0, 0), rgb(255, 213, 0));
				filter: blur(7em);
				opacity: 0.3;
				@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
					left: 20%;
				}
			}

			&__form-container {
				.form-container-card {
					border-radius: 32px;
					padding: 0px;

					.title {
						font-size: 30px;
					}

					.ant-card-body {
						padding: 32px;
						@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
							padding: 32px;
						}
						label {
							text-transform: uppercase;
							color: #4f5661;
							font-weight: 700;
						}
					}
				}
			}
			&__info-container {
				.info-container-card {
					background: transparent;
					border: none;
					.title {
						font-size: 48px;
						line-height: 1;

						@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
							text-align: center;
						}
					}
					.ant-card-body {
						padding: 32px;
						padding-right: 80px;
						color: #ffffff;
						display: flex;
						flex-direction: column;
						gap: 32px;

						@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
							padding: 32px 0;
						}

						p {
							font-weight: 300;
							font-size: 16px;
							@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
								text-align: center;
							}
						}

						.ant-card-meta {
							.ant-card-meta-title {
								font-family: "DM Sans", sans;
								color: #ffffff;
								font-size: 24px;
								font-weight: 700;
							}
							.ant-card-meta-description {
								color: #ffffff;
								font-weight: 300;
								font-size: 16px;
							}
						}
					}
				}
			}
		}
		&__footer {
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				padding: 16px 32px;
			}
			padding: 40px 80px;
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 24px;

			.divider {
				border-color: #1f1f1f;
			}

			.copyright {
				color: #d9d9d9;
				font-size: 14px;
			}
		}
	}
	.ant-card-body {
		&::before,
		&::after {
			display: none;
		}
		justify-content: space-between;
		@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
			padding: 0px;
		}
	}
`;

export default StyledGetStarted;

